import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class FormControlService {
  constructor(private readonly translateService: TranslateService) {}

  public getErrorMessages(
    control: AbstractControl,
    fieldName?: string,
    translationKeys?: Record<string, string>
  ): string[] {
    return this.getFormattedErrors(control?.errors, fieldName, translationKeys);
  }

  public getErrorMessagesAfterTouch(
    inputName: string,
    formGroup: FormGroup
  ): string[] {
    const control = formGroup.get(inputName);
    const messages = this.getErrorMessages(control, inputName);

    return control?.touched && messages;
  }

  public getFormattedErrors(
    errors: ValidationErrors,
    fieldName?: string,
    translationKeys?: Record<string, string>
  ): string[] {
    if (!errors) {
      return [];
    }
    return Object.keys(errors)
      .filter((errorName) => errors[errorName])
      .map((errorName) => {
        return this.translateService.instant(
          `form${
            (fieldName &&
              `.${fieldName.replace(/([A-Z])/g, '_$1').toLowerCase()}`) ||
            ''
          }.error.${errorName}.message`,
          translationKeys
        );
      });
  }

  public hasError(control: AbstractControl): boolean {
    return Boolean(control?.errors) && Object.keys(control.errors)?.length > 0;
  }

  public hasErrorAfterTouched(control: AbstractControl): boolean {
    return (
      control.touched &&
      Boolean(control?.errors) &&
      Object.keys(control.errors)?.length > 0
    );
  }
}
